
import { handleError } from '@/plugins/helper'
import AuroraBackground from '~/components/common/aurora-background.vue'
import BtnReadmore from '~/components/common/btn-readmore.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import RelatedArticles from '~/sections/vision/ai-workspace/related-articles.vue'
import VisionChildKv from '~/sections/vision/child-kv.vue'
import AiProgram from '~/sections/vision/child-program.vue'
import Initiatives from '~/sections/vision/initiatives.vue'

export default {
  components: {
    TextPressure,
    PageBottom,
    FooterNew,
    AuroraBackground,
    VisionChildKv,
    RelatedArticles,
    AiProgram,
    BtnReadmore,
    Initiatives
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  async asyncData({ $content }) {
    const articles = await $content('article/all')
      .limit(4)
      .only(['url', 'thumbnail', 'thumbnailUrl', 'category', 'publicDateStr', 'title', 'media'])
      .fetch()
      .catch(handleError)

    return { articles: Array.isArray(articles) ? articles : [articles] }
  },
  data() {
    return {
      articles: [],
      initiatives: [
        {
          title: 'リーダーズAI',
          description:
            '社内の考え方や判断基準をAIに学習させ、社員がいつでもチャットツール（TeamsやSlackなど）を通じて相談できる「御社専用のAI」を構築するサービスです。営業や企画、採用など様々なシーンで現場の悩みを解消し、組織全体の判断の品質の向上を実現します。'
        },
        {
          title: 'Devin',
          description:
            'Cognition AI社が開発した自律的AIソフトウェアエンジニアの日本展開を担当しています。チームの一員として協調し、開発現場の生産性を飛躍的に向上させる革新的なソリューションです。DeNA社内でも利用しており、開発効率の劇的な改善を実現しています。'
        },
        {
          title: 'AI研修',
          description:
            'DeNAの社内で展開しているコンテンツを外販しています。全社員のAIリテラシー向上を目的とした体系的な教育プログラムを提供します。基礎知識から実践的な活用方法まで、組織のAI導入レベルに応じてカスタマイズした研修を実施します。'
        }
      ]
    }
  },
  head() {
    const title = 'B2B Service | VISION'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
}
